module.exports = __webpack_public_path__ + "img/10.2-gallery.c759b7bc.jpg";